import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chevron-down\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.99978 3.34247L2.19978 0.54247L0.779785 1.95247L4.26979 5.45247C4.65979 5.84247 5.28979 5.84247 5.67979 5.45247L9.17978 1.95247L7.75979 0.532471L4.95978 3.32247L4.99978 3.34247Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol